<template>
    <img :src="iconPath" alt="PNG File Icon" />
  </template>
  
  <script>
  import iconPath from '../../../icons/png-fileicon.svg';
  
  export default {
    name: 'IconPngFile',
    data() {
      return {
        iconPath,
      };
    },
  };
  </script>
  
  <style scoped>
  img {
    width: 21px;
    height: 24px;
  }
  </style>
  